import { useRef } from 'react';

/**
 * Hook to track time spent on the form
 * Used to measure completion_time_seconds and time_spent_seconds
 */
export const useFormTracking = () => {
  const startTimeRef = useRef<number | null>(null);

  /**
   * Start tracking form time
   */
  const startTracking = () => {
    startTimeRef.current = Date.now();
  };

  /**
   * Get elapsed time in seconds since tracking started
   */
  const getElapsedSeconds = (): number => {
    if (!startTimeRef.current) return 0;
    return Math.floor((Date.now() - startTimeRef.current) / 1000);
  };

  /**
   * Reset tracking
   */
  const resetTracking = () => {
    startTimeRef.current = null;
  };

  return {
    startTracking,
    getElapsedSeconds,
    resetTracking,
  };
};
